export { default } from '@material-ui/core/Paper';
